import React from 'react';
interface BioProps {
  onOpenPopup: () => void;
}
export function Bio({
  onOpenPopup
}: BioProps) {
  return <section className="py-20 bg-black border-t border-gray-900" data-id="element-8">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-9">
        <div className="flex flex-col lg:flex-row items-center gap-12 max-w-6xl mx-auto" data-id="element-10">
          {/* Left Column - Image */}
          <div className="w-full lg:w-5/12 flex justify-center" data-id="element-11">
            <div className="w-full max-w-md aspect-[3/4] relative overflow-hidden" data-id="element-12">
              <img src="https://cdn.magicpatterns.com/uploads/9ZLJvp44zvtFx11raDBuSz/IMG_3494_(1).webp" alt="Tomás Benavidez" className="w-full h-full object-cover" data-id="element-13" />
              {/* Difuminado hacia el fondo negro en todos los bordes */}
              <div className="absolute inset-0 pointer-events-none" style={{
              background: 'linear-gradient(to bottom, rgba(0,0,0,0.55) 0%, rgba(0,0,0,0) 22%, rgba(0,0,0,0) 70%, rgba(0,0,0,1) 100%)'
            }} data-id="element-14" />
              <div className="absolute inset-0 pointer-events-none" style={{
              background: 'linear-gradient(to right, rgba(0,0,0,0.9) 0%, rgba(0,0,0,0) 18%, rgba(0,0,0,0) 82%, rgba(0,0,0,0.9) 100%)'
            }} data-id="element-15" />
            </div>
          </div>

          {/* Right Column - Text */}
          <div className="w-full lg:w-7/12 text-left space-y-6" data-id="element-16">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold leading-snug md:leading-tight text-center lg:text-left" data-id="element-17">
              🔥 Así Construí un Negocio de{' '}
              <span className="text-brand-orange" data-id="element-18">
                Más de 100.000 USD al Año
              </span>{' '}
              Vendiendo Mis Propios Infoproductos en Internet
            </h2>

            <div className="space-y-4 text-gray-300 text-base sm:text-lg leading-relaxed text-left" data-id="element-19">
              <p data-id="element-20">
                Hola, soy{' '}
                <strong className="text-white" data-id="element-21">Tomás Benavidez</strong> y hace
                algunos años trabajaba en un empleo que no me gustaba mientras
                buscaba una forma de cambiar mi realidad económica.
              </p>
              <p data-id="element-22">
                Después de mucho aprendizaje descubrí el mundo de los productos
                digitales y construí un negocio que me permitió generar{' '}
                <strong className="text-white" data-id="element-23">
                  más de 6 cifras en dólares
                </strong>{' '}
                vendiendo mis propios infoproductos por internet.
              </p>
              <p data-id="element-24">
                Hoy comparto el mismo sistema con cientos de alumnos que están
                construyendo sus propios negocios digitales.
              </p>
              <p data-id="element-25">
                Si sentís que naciste para algo más que intercambiar tiempo por
                dinero y querés crear una fuente de ingresos online, esta{' '}
                <strong className="text-white" data-id="element-26">Masterclass</strong> es para vos.
              </p>
              <p data-id="element-27">
                Voy a mostrarte el{' '}
                <span className="text-brand-orange font-semibold" data-id="element-28">
                  sistema paso a paso
                </span>{' '}
                que utilizo personalmente para crear, vender y escalar productos
                digitales.
              </p>
              <p className="font-bold text-white" data-id="element-29">
                Registrate gratis y descubrí cómo empezar tu propio negocio de
                ebooks.
              </p>
            </div>

            <div className="pt-6" data-id="element-30">
              <button onClick={onOpenPopup} className="w-full sm:w-auto px-8 py-4 bg-brand-orange hover:bg-red-600 text-white text-lg font-bold rounded-lg transition-all transform hover:scale-105 active:scale-95 box-glow" data-id="element-31">
                ACCEDER AL CURSO GRATIS
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}